<template>
    <CodeGenerator></CodeGenerator>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const CodeGenerator = defineAsyncComponent(() =>
    import("../../components/ProjectManagement/CodeGenerator/CodeGenerator.vue")
);

export default {
    name: "Project_CodeGenerator", //The name you are in should not equal the name of the component you are importing.
    components: { CodeGenerator, AuthLayout },
};
</script>
